import React from 'react'
// import asyncComponent from 'src/components/asyncComponent';

// export default asyncComponent({
//   loader: () => import('./StreetLightManagement'),
// });

export default React.lazy(() => import('./StreetLightManagement'))
